import React from 'react';
import './About.css'
import img from '../../images/sabbir.jpg'
import img1 from '../../images/about.jpg'
import img2 from '../../images/about1.jpg'
import { Col, Container, Row } from 'react-bootstrap';
import { FaGithub, FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";

const About = () => {
  return (
    <div className='main-black'>
      <h2 style={{color:'whitesmoke', margin:'25px'}}>About Me</h2>
      <div className="w-100 m-auto text-center">

        <div>
          <div className="profile-pic mt-5 mb-5 " >
            <img className=' animate__heartBeat animate__slideInUp' src={img1} alt="" />
          </div>

          <div>
            <div >
              <h1 className="title about-name  animate__heartBeat animate__zoomInDown">I'M SABBIR AHMED NAYEEM</h1>
            </div>
            <p className="my-description animate__heartBeat  animate__zoomInDown" >
              I am a react developer with knowing some
              framework for the frontend and the backend. I know Basic
              MySQL but basically a MERN developer. I always focus on
              learning new technology.
            </p>

            <div className="mt-5 mb-5 animate__heartBeat  animate__zoomInDown" >
            <div >
                               <button className='icon-button'>
                                    <a className='icon-button' href="https://github.com/nayeem98746"><FaGithub></FaGithub></a>
                                    
                                </button>
                               <button className='icon-button'>
                                    <a href="https://www.facebook.com/sabbirahmed.nayeem.10" className='icon-button'>  <FaFacebook></FaFacebook> </a>
                               </button>
                               <button className='icon-button'> <a href="https://www.instagram.com/sabbirahmednayeem/" className='icon-button'> <FaInstagram></FaInstagram> </a></button>
                                <button className='icon-button'><a href="https://www.linkedin.com/in/sabbir-ahmed-b98b0a226/" className='icon-button'> <FaLinkedin></FaLinkedin> </a></button>
                                
                            </div>
            </div>
          </div>


          <div >
            {/* <Footer></Footer> */}
          </div>
        </div>
        <Container>
  <Row className='m-auto'>
    <Col>
      <h2 className='my-skill text-center'>My Skills</h2>
      <li className= ' text-left mt-5 mb-2  col-sm-12 sklis'>Expertise: </li>
      <div className=' expertise-1 '>
        <h3 className='skills-btn'>React js</h3>
        <h3 className='skills-btn'>React Router</h3>
        <h3 className='skills-btn'>Material UI</h3>
        <h3 className='skills-btn'> HTML 5 </h3>
        <h3 className='skills-btn'> CSS 3 </h3>
        <h3 className='skills-btn'> Bootstrap  </h3> 
       
      
      </div>
      <div>
        <h3 className='skills-js'> JavaScript(ES6) </h3>
        </div>
      <li className= ' text-left mt-5 mb-2  col-sm-12 sklis'>Comfortable: </li>
      <div className='  expertise '>
        <h3 className='skills-btn'>React js</h3>
        <h3 className='skills-btn'>Redux</h3>
        <h3 className='skills-btn'>MongoDB</h3>
        <h3 className='skills-btn'>Database</h3>
        <h3 className='skills-btn'>Express</h3>
         
      </div>
      <li className= ' text-left mt-5 mb-2  col-sm-12 sklis'>Tools: </li>
      <div className='  expertise '>
        <h3 className='skills-btn'>Git</h3>
        <h3 className='skills-btn'>Heroku</h3>
        <h3 className='skills-btn'>Firebase</h3>
        <h3 className='skills-btn'> MS Office </h3>
        <h3 className='skills-btn'> VS code </h3>
        <h3 className='skills-btn'> Netlify </h3>
      
      </div>
     
    </Col>
    <Col >
     <div>
     <h2 className='my-skill'>My Education</h2>
      <li className= '  sklis'>SSC: </li>
       <h2 className='education-text'> Sristy Academic School, Tangail, </h2>
       <h3 className='education-text'>Session:2017-2018</h3>
     </div>
     <div>
     <li className= '  sklis'>HSC: </li>
       <h2 className='education-text'> Major General Mahmudul Hassan Adarsha College,Tangail </h2>
       <h3 className='education-text'>Session:2019-2020</h3>
     </div>
    </Col>
  </Row>
  
</Container>

      </div>
    </div>
  );
};

export default About;